import { useParams } from 'react-router-dom';

const useParam = <K extends string>(paramKey: K) => {
  const params = useParams<{ [key: string]: string | undefined }>();
  return params[paramKey];
};

export default useParam;
